import { supabase } from './supabase';
import { logger } from './logger';

interface OrderItem {
  name: string;
  quantity: number;
  price: number;
  variant?: string;
}

interface ShippingAddress {
  line1: string;
  line2?: string;
  city: string;
  postal_code: string;
  country: string;
}

interface OrderConfirmationData {
  orderNumber: string;
  customerName: string;
  customerEmail: string;
  items: OrderItem[];
  subtotal: number;
  shipping: number;
  total: number;
  shippingAddress: ShippingAddress;
}

interface WelcomeEmailData {
  customerName: string;
  customerEmail: string;
}

interface OrderStatusUpdateData {
  orderNumber: string;
  customerName: string;
  customerEmail: string;
  newStatus: string;
  trackingNumber?: string;
}

async function sendEmail(
  type: 'order_confirmation' | 'welcome' | 'order_status_update',
  to: string,
  data: Record<string, unknown>
): Promise<{ success: boolean; error?: string }> {
  try {
    const { data: result, error } = await supabase.functions.invoke('send-email', {
      body: { type, to, data },
    });

    if (error) {
      logger.error('Error sending email:', error);
      return { success: false, error: error.message };
    }

    return { success: true, ...result };
  } catch (err) {
    logger.error('Failed to send email:', err);
    return { success: false, error: 'Failed to send email' };
  }
}

export async function sendOrderConfirmationEmail(data: OrderConfirmationData): Promise<{ success: boolean; error?: string }> {
  const { customerEmail, ...emailData } = data;
  return sendEmail('order_confirmation', customerEmail, emailData);
}

export async function sendWelcomeEmail(data: WelcomeEmailData): Promise<{ success: boolean; error?: string }> {
  const { customerEmail, customerName } = data;
  return sendEmail('welcome', customerEmail, { customerName });
}

export async function sendOrderStatusUpdateEmail(data: OrderStatusUpdateData): Promise<{ success: boolean; error?: string }> {
  const { customerEmail, ...emailData } = data;
  return sendEmail('order_status_update', customerEmail, emailData);
}
